import React from "react"
import { Drawer as DrawerPrimitive } from "@base-ui/react/drawer"
import { cn } from "../utils"

export type DrawerDescriptionProps = {
  children?: React.ReactNode
  className?: string
}

const descriptionStyles = "m-0 text-base font-normal leading-6 text-gray-700"

/** Supporting copy under the title. Describes the panel to assistive technology. */
export function DrawerDescription({
  children,
  className
}: DrawerDescriptionProps) {
  return (
    <DrawerPrimitive.Description
      data-slot="drawer-description"
      className={cn(descriptionStyles, className)}
    >
      {children}
    </DrawerPrimitive.Description>
  )
}

DrawerDescription.displayName = "Drawer.Description"
